import { useMutation } from '@apollo/client';
import { CREATE_PLOTS, DELETE_PLOTS, UPDATE_PLOTS } from 'graphql/secure/mutations/plot.mutations';
import {
  ICreatePlotsInput,
  IUpdatePlotInput,
} from 'graphql/secure/mutations/types/plots-muation.types';
import { IPlot } from 'types/plot.types';

const usePlotsMutations = () => {
  const [createPlots, { loading: loadingCreate }] = useMutation<
    { createPlots: { plots: IPlot[] } },
    { inputs: ICreatePlotsInput[] }
  >(CREATE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  const [updatePlots, { loading: loadingUpdate }] = useMutation<
    { createPlots: { plots: IPlot[] } },
    { inputs: IUpdatePlotInput[] }
  >(UPDATE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  const [deletePlots, { loading: loadingDelete }] = useMutation<
    { deletePlots: { plots: { id: string }[] } },
    { ids: string[] }
  >(DELETE_PLOTS, {
    refetchQueries: ['GetDataset', 'GetGeoDataProcess', 'GetPlots'],
  });

  return {
    loading: loadingCreate || loadingUpdate || loadingDelete,
    createPlots,
    updatePlots,
    deletePlots,
  };
};

export default usePlotsMutations;
